<template>
  <div>
    <div v-show="not_found" class="container">
      <h2 class="title" style="font-size: 52px;">Celular não cadastrado!</h2>
      <h2 class="title" style="font-size: 52px;">Por favor, teste com número de CPF cadastrado.</h2>
    </div>
    <div v-show="!not_found" class="container">
      <h2 class="title">Informe nº do celular</h2>
      <div v-if="error_message" class="error-panel">{{ error_message }}</div>
      <div class="input">
        <input type="text" maxlength="14"
        v-model="tel"
        v-mask="'(##)#####-####'"
        @change="testaTel()">
      </div>
      <div class="keyboard">
        <table class="numeric-keyboard">
            <tbody>
                <tr>
                    <td class="numeric-keyboard-key" @click="setTel('1')">1</td>
                    <td class="numeric-keyboard-key" @click="setTel('2')">2</td>
                    <td class="numeric-keyboard-key" @click="setTel('3')">3</td>
                </tr>
                <tr>
                    <td class="numeric-keyboard-key" @click="setTel('4')">4</td>
                    <td class="numeric-keyboard-key" @click="setTel('5')">5</td>
                    <td class="numeric-keyboard-key" @click="setTel('6')">6</td>
                </tr>
                <tr>
                    <td class="numeric-keyboard-key" @click="setTel('7')">7</td>
                    <td class="numeric-keyboard-key" @click="setTel('8')">8</td>
                    <td class="numeric-keyboard-key" @click="setTel('9')">9</td>
                </tr>
                <tr>
                    <td class="numeric-keyboard-key" @click="deleteTel()">
                      <i class="ui eraser icon" style="color: gray;"></i>
                    </td>
                    <td class="numeric-keyboard-key" @click="setTel('0')">0</td>
                    <td id="confirm" :class="['numeric-keyboard-key', { inactive: !canConfirm }]"
                    @click="confirmTel()">
                      <i class="ui check icon" style="color: #2f80ed;"></i>
                    </td>
                </tr>
            </tbody>
        </table>
      </div>
    </div>
    <div class="footer-btn">
      <div id="back-btn" class="btn btn-cancel" @click.prevent="$emit('backClicked', 'StartPage');">
        <i class="ui sign-out icon"></i>
        <span>Cancelar</span>
      </div>
    </div>
  </div>
</template>
<script>
//import { NumericKeyboard } from 'numeric-keyboard/dist/numeric_keyboard.vue'
import { mask } from 'vue-the-mask'
export default {
  /* components: {
    NumericKeyboard
  }, */
  directives: {
    mask
  },
  data() {
    return {
      tel: '',
      keyPressed: '',
      not_found: false,
      is_loading: false,
      error_message: ''
    }
  },
  computed: {
    telDigits() {
      return this.tel.replace(/\D/g, '');
    },
    canConfirm() {
      return !this.is_loading && this.telDigits.length === 11;
    }
  },
  methods: {
    testaTel(num) {
      console.log(this.tel);
    },
    setTel(key) {
      if (this.is_loading || this.telDigits.length >= 11) return;
      this.error_message = '';
      this.tel = this.tel + key;
    },
    deleteTel() {
      //this.cpf = this.cpf.substring(0, (this.cpf.length - 1));
      this.tel = '';
      this.error_message = '';
    },
    async confirmTel() {
      if (!this.canConfirm) {
        this.error_message = 'Informe um celular com DDD.';
        return;
      }
      this.is_loading = true;
      this.error_message = '';
      try {
        const { data } = await axios.get('api/kiosk/customer/customerschedulingcel/' + encodeURIComponent(this.tel));
        if (data.data.length > 0) {
          let customer = data.data;
          if (customer.length > 1) {
            this.$emit('foundCustomer', customer);
            this.$emit('buttonClicked', 'CheckinCustomers')
          } else {
            const response = await axios.get('api/kiosk/customer/customerschedulingid/' + customer[0].id);
            this.$emit('setRequisitions', response.data.data.schedulings);
            this.$emit('buttonClicked', 'FinishCheckin')
          };
        } else {
          console.log('nao existe cliente');
          var app = this;
          this.not_found = true;
          this.tel = '';
          setTimeout(function() {
            app.not_found = false;
          }, 6000);
        };
      } catch (err) {
        this.error_message = 'Não foi possível consultar o celular. Verifique a conexão e tente novamente.';
      } finally {
        this.is_loading = false;
      }
    }
  }
}
</script>
<style scoped>
@media only screen and (min-width: 320px) {
  .input {
    width: 100%;
    height: 46px;
  }
  input {
    margin-left: 22px;
    font-size: 28px;
  }
  .keyboard {
    width: fit-content;
  }
  /* .footer-btn {
    width: 100%;
    margin: 0 auto;
    margin-top: 20px;
    padding: 0px;
    bottom: 42px;
    left: 0px;
  } */
  /* .btn {
    width: 130px;
    margin: 0 auto;
    height: 46px;
    padding: 0 14px;
  }
  .btn-cancel i {
    position: inherit;
    font-size: 20px;
  }
  .btn-cancel span {
    font-size: 20px;
  } */
}

@media only screen and (min-width: 500px) {
  .container {
    position: absolute;
    top: 70%;
    left: 25%;
    width: 100%;
    margin: -24% 0 0 -25%;
  }
  h2 {
    font-size: 42px;
  }
  .input {
    width: 30%;
    height: 80px;
  }
  input {
    margin-left: 30px;
    font-size: 46px;
  }
  .keyboard {
    width: 30%;
  }
  /* .footer-btn {
    position: fixed;
  } */
  /* .btn {
    margin: 0px;
    width: 180px;
    height: 60px;
  }
  .btn-cancel i {
    position: absolute;
    font-size: 26px;
  }
  .btn-cancel span {
    padding-left: 43px;
    font-size: 24px;
  } */
}

h2 {
  color: #fff;
}
.input {
  margin: 0 auto;
  padding: 0px 40px;
  background: #fff;
  border-radius: 500px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}
input {
  float: left;
  width: 80%;
  height: -webkit-fill-available;
  text-align: center;
  border: none;
  outline: none;
}
.keyboard {
  //width: 30%;
  height: 300px;
  margin: 0 auto;
  margin-top: 20px;
}
.numeric-keyboard {
  width: 100%;
  height: 100%;
  table-layout: fixed;
  border-collapse: separate;
  border-spacing: 10px;
  font-size: 1.8em;
  text-align: center;
}
.numeric-keyboard-key {
  padding: 10px;
  touch-action: manipulation;
  transition: background 0.5s;
  color: #555;
  background: #fff;
  border-radius: 500px;
  box-shadow: 0px 10px 8px rgba(0, 0, 0, 0.22), 0 1px 2px rgba(0, 0, 0, 0.23);
}
.numeric-keyboard-key.active {
  background: lightblue;
}
.inactive {
  background: #c3c3c3;
}
.inactive i {
  color: #fff!important;
}
</style>



// WEBPACK FOOTER //
// src/components/CheckinTel.vue